import Vue from 'vue';
// Components
Vue.component('SvgElement', () => import('@/components/base/svg/SvgElement.vue'));
